import shops from 'raw-loader!./shops.txt'

export default {
  shops,
}
